import React from 'react';
import { Routes, Route, Navigate, useLocation, Link } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FarmProvider } from './contexts/FarmContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import SetupFarm from './pages/SetupFarm';
import SetupCycle from './pages/SetupCycle';
import Dashboard from './pages/Dashboard';
import Kapitani from './pages/Kapitani';
import HAVVA from './pages/HAVVA';
import Avialite from './pages/Avialite';
import Elliance from './pages/Elliance';
import ITraceability from './pages/ITraceability';
import Farm from './pages/Farm';
import FarmManagement from './pages/FarmManagement';
import { Sales, Cost, Analytics as FinancialAnalytics, Transaction } from './pages/financial';
import Utilisation from './pages/Utilisation';
import Reports from './pages/Reports';
import DatabaseManagement from './pages/DatabaseManagement';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import PlantingSchedule from './pages/PlantingSchedule';
import Harvest from './pages/Harvest';
import Attendance from './pages/Attendance';
import OrganizationManagement from './pages/OrganizationManagement';
import Documentation from './pages/Documentation';

function App() {
  return (
    <AuthProvider>
      <FarmProvider>
        <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/setup/farm" element={<SetupFarm />} />
        <Route path="/setup/cycle" element={<SetupCycle />} />
        <Route path="/*" element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/kapitani" element={<Kapitani />} />
                <Route path="/havva" element={<HAVVA />} />
                <Route path="/avialite" element={<Avialite />} />
                <Route path="/elliance" element={<Elliance />} />
                <Route path="/itraceability" element={<ITraceability />} />
                <Route path="/farm" element={<Farm />} />
                <Route path="/farm-management" element={<FarmManagement />} />
                <Route path="/planting-schedule" element={<PlantingSchedule />} />
                <Route path="/harvest" element={<Harvest />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/analytics" element={<FinancialAnalytics />} />
                <Route path="/financial/sales" element={<Sales />} />
                <Route path="/financial/cost" element={<Cost />} />
                <Route path="/financial/analytics" element={<FinancialAnalytics />} />
                <Route path="/financial/transaction" element={<Transaction />} />
                <Route path="/utilisation" element={<Utilisation />} />
                <Route path="/reports" element={<Reports />} />
                {/* Legacy singular path — preserve any old bookmarks/links. */}
                <Route path="/report" element={<Navigate to="/reports" replace />} />
                <Route path="/database-management" element={<DatabaseManagement />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/organization-management" element={<OrganizationManagement />} />
                <Route path="/documentation" element={<Documentation />} />
                {/* 404 catch-all — friendlier than a blank screen when a typo'd
                    or stale URL is hit. */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        } />
        </Routes>
      </FarmProvider>
    </AuthProvider>
  );
}

// Lightweight 404 — no external icons so the bundle stays the same size.
const NotFound = () => {
  const location = useLocation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="text-6xl font-bold text-gray-300 mb-2">404</div>
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">Page not found</h1>
      <p className="text-sm text-gray-500 mb-6 max-w-md">
        <code className="bg-gray-100 px-2 py-0.5 rounded text-gray-700">{location.pathname}</code> doesn't match any route in the dashboard.
      </p>
      <Link to="/dashboard" className="btn-primary">Go to dashboard</Link>
    </div>
  );
};

export default App;
